export default __webpack_public_path__ + "static/media/Payment-Details.f5f42428.jpg";